module.exports = __webpack_public_path__ + "images/hand-1.png";